import { render, staticRenderFns } from "./topo-services.vue?vue&type=template&id=319f736f&"
import script from "./topo-services.vue?vue&type=script&lang=ts&"
export * from "./topo-services.vue?vue&type=script&lang=ts&"
import style0 from "./topo-services.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports